import { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../redux';

const useCashbackList = () => {
  const dispatch = useDispatch();

  const cashbackList = useSelector(s => s.cashback.cashbackList);
  const cashbackCount = useSelector(s => s.cashback.cashbackCount);
  const currentPage = useSelector(s => s.cashback.currentPage);
  const itemsOnPage = useSelector(s => s.cashback.itemsOnPage);

  const [state, setState] = useState({
    page: currentPage,
  });

  useEffect(() => {
    const skip = state.page * itemsOnPage;
    dispatch(
      actions.getCashbackList({
        skip,
        limit: itemsOnPage,
      }),
    );
  }, [dispatch, state.page, itemsOnPage]);

  const handlePageChange = useCallback(
    page => {
      setState(prev => ({ ...prev, page }));
      dispatch(actions.setCurrentPage(page));
    },
    [dispatch],
  );

  const handleDelete = useCallback(
    id => {
      dispatch(actions.deleteCashback(id));
    },
    [dispatch],
  );

  const handleItemsOnPageChange = useCallback(
    value => {
      dispatch(actions.setItemsOnPage(value));
      setState(prev => ({ ...prev, page: 0 }));
      dispatch(actions.setCurrentPage(0));
    },
    [dispatch],
  );

  return {
    values: {
      items: cashbackList || [],
      count: cashbackCount || 0,
      state,
      activeItemsOnPage: itemsOnPage,
    },
    handlers: {
      handlePageChange,
      handleDelete,
      handleItemsOnPageChange,
    },
  };
};

export default useCashbackList;
